'use strict';

var React = require('react');

var SvgComposeMajor = function SvgComposeMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M14.666 3.603a.5.5 0 0 1 .707 0l1.06 1.061a.5.5 0 0 1 0 .707l-.957.957-1.767-1.767.957-.958Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.002 5.268 1.767 1.767-3.83 3.831a2 2 0 0 1-1.348.585l-.772.025a.25.25 0 0 1-.258-.258l.025-.772a2 2 0 0 1 .585-1.348l3.83-3.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.25a2.25 2.25 0 0 1 2.25-2.25h1.83a.75.75 0 1 0 0-1.5h-1.83a3.75 3.75 0 0 0-3.75 3.75v5.5a3.75 3.75 0 0 0 3.75 3.75h5.5a3.75 3.75 0 0 0 3.75-3.75v-1.83a.75.75 0 0 0-1.5 0v1.83a2.25 2.25 0 0 1-2.25 2.25h-5.5a2.25 2.25 0 0 1-2.25-2.25v-5.5Z"
  }));
};
SvgComposeMajor.displayName = "ComposeMajor";

exports.SvgComposeMajor = SvgComposeMajor;
